import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SecurityAdminService {
  private url_la = environment.BASE_LA;

  constructor(private http: HttpClient) { }

  get baseUrl() {
    return this.url_la;
  }

  /**
   * Obtiene todos los usuarios con información de seguridad
   */
  getAllUsersWithSecurity = async (params: any = {}) => {
    const headers = { 'content-type': 'application/json' };
    const request = params;

    try {
      return lastValueFrom(
        this.http.get<any>(`${this.baseUrl}/api/admin/security/users`, {
          headers: headers,
          params: request,
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Agrega o actualiza el correo electrónico de un usuario
   */
  setUserEmail = async (userId: string, email: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/set-email`,
          { userId, email },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Elimina el correo electrónico de un usuario
   */
  deleteUserEmail = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/delete-email`,
          { userId },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Resetea 2FA Authenticator de un usuario
   */
  reset2FAAuthenticator = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/reset-2fa-authenticator`,
          { userId },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Resetea 2FA SMS de un usuario
   */
  reset2FASMS = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/reset-2fa-sms`,
          { userId },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Agrega o actualiza el número de teléfono de un usuario
   */
  setUserPhone = async (userId: string, phone: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/set-phone`,
          { userId, phone },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Obtiene el historial completo de logins de un usuario
   */
  getUserLoginHistory = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.get<any>(`${this.baseUrl}/api/admin/security/user/${userId}/login-history`, {
          headers: headers
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Desbloquea una cuenta manualmente
   */
  unlockAccount = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/account-lockout/unlock`,
          { userId },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Resetea el contador de incidencias
   */
  resetIncidents = async (userId: string) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/account-lockout/reset-incidents`,
          { userId },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Activa o desactiva 2FA Authenticator de un usuario
   */
  toggle2FAAuthenticator = async (userId: string, active: boolean) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/toggle-2fa-authenticator`,
          { userId, active },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Activa o desactiva 2FA SMS de un usuario
   */
  toggle2FASMS = async (userId: string, active: boolean) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/toggle-2fa-sms`,
          { userId, active },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Activa o desactiva 2FA globalmente
   */
  toggleGlobal2FA = async (enabled: boolean) => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.post<any>(`${this.baseUrl}/api/admin/security/toggle-global-2fa`,
          { enabled },
          { headers: headers }
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Obtiene el estado global de 2FA
   */
  getGlobal2FAStatus = async () => {
    const headers = { 'content-type': 'application/json' };
    try {
      return lastValueFrom(
        this.http.get<any>(`${this.baseUrl}/api/admin/security/global-2fa-status`, {
          headers: headers
        })
      );
    } catch (error) {
      console.error(error);
    }
  };
}
